import { useContext } from "react";
import { Table } from '../../../components/table/Table';
import { FeatureContext } from "../../../Context";
import { downloadAttachment, lang } from "../../../Utils";
import { Spinner, useBoolean } from "@chakra-ui/react";
import { BsDownload } from "react-icons/bs";
import { ButtonIcon } from "../../../components/button/Button";
import { getOrdersAttachment } from "../Services";


const DownloadAttachment = ({ data }) => {

  const [loader, setLoader] = useBoolean();
  const onClick = () => {
    setLoader.on();
    getOrdersAttachment({ url: data.documentUrl })
      .then(data => downloadAttachment(data?.data[0]))
      .finally(_ => setLoader.off());
  }
  return (!!data.documentUrl) ? <ButtonIcon type="button" variant="dark" size="sm" onClick={onClick}>
    {(loader) ? <Spinner size="sm" /> : <BsDownload />}
  </ButtonIcon> : null;
}

const OrderConfirmation = () => {

  const context = useContext(FeatureContext);

  return <div>
    <Table dataSet={context?.orderConfirmation} pagination={true} hover={false}>
      <Table.Caption>{lang('Order Confirmation List')}</Table.Caption>
      <Table.Header>
        <Table.Header.Column sortKey={"orderDate"} sortable={true}>{lang('Order Date')}</Table.Header.Column>
        <Table.Header.Column >{lang('Download Confirmation')}</Table.Header.Column>
      </Table.Header>
      <Table.Body dataSet={context?.invoices} noDataMessage={lang('No Data available to display')}>
        <Table.Body.Date label={lang('Order Date')} field="orderDate" />
        <Table.Body.Component label={lang('Download Confirmation')} rendercomponent={DownloadAttachment} />
      </Table.Body>
    </Table>
  </div>

}

export default OrderConfirmation;